import { COLORS } from '~/themes/common'

const style = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    position: 'relative',
    padding: 28,
    boxSizing: 'border-box',
    '&.galleryMode': {
      padding: 0,
    },
    '@media screen and (min-height: 400px) and (max-height: 706px)': {
      display: 'block',
    },
  },
  filesContainer: {
    position: 'relative',
    width: '100%',
    '&.galleryMode': {
      marginTop: 30,
    },
    height: '60vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    '@media screen and (max-width: 1024px)': {
      height: '54vh',
    },
  },
  divider: {
    background: '#EAEAEA',
    height: 1,
    width: '100%',
    paddingLeft: '60px',
    marginLeft: '-30px',
    marginTop: 20,
  },
  fileContainer: {
    position: 'relative',
    cursor: 'pointer',
    width: '100%',
    paddingTop: '100%',
    border: '2px solid #B4BFD9',
    borderRadius: 3,
    '&.selected': {
      border: `2px solid ${COLORS.palette.primaryBlue}`,
    },
  },
  loadingContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9,
    background: 'rgba(256, 256, 256, 0.7)',
    '@media screen and (max-width: 1279px)': {
      top: -10,
      left: -10,
    },
  },
  backTitle: {
    width: '100%',
    fontSize: 18,
    color: COLORS.palette.black,
    '@media screen and (min-height: 400px) and (max-height: 706px)': {
      fontSize: 16,
    },
  },
  backContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  listFileContainer: {
    overflowY: 'auto',
  },
  containerLoadMore: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: 5,
    fontSize: 12,
  },
  bulkActionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 62,
    borderBottom: '1px solid #EAEAEA',
    marginBottom: 10,
    transition: 'height 0.15s',
  },
  collapse: {
    height: 0,
    borderBottom: 'none',
  },
})

export default style
